import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BusinessSectorListService {

  constructor(private httpClient: HttpClient) {
  }

  getBusinessSectorList(): Observable<any> {
    return this.httpClient.get(
      `${environment.API_ENDPOINT}business-sectors`)
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
